export default [
  {
    id: 'suit',
    filename: '202507-namanyay-suit.jpg',
    title: 'Formal Portrait',
    date: 'July 2025',
    description: 'Professional portrait in formal suit'
  },
  {
    id: 'star-spangled',
    filename: '202506-namanyay-star-spangled.jpg',
    title: 'Star Spangled',
    date: 'June 2025',
    description: 'Professional portrait in star-spangled attire'
  },
  {
    id: 'interview',
    filename: '202507-namanyay-interview.jpeg',
    title: 'Interview',
    date: 'July 2025',
    description: 'Professional interview photograph'
  },
  {
    id: 'presenting',
    filename: '202508_namanyay_presenting.jpeg',
    title: 'Presenting',
    date: 'August 2025',
    description: 'Speaking and presenting at an event'
  }
]




// WEBPACK FOOTER //
// ./src/components/Media/data.js